import { Outlet } from "@remix-run/react";
import { Panel } from "~/components/base/panel";
import { action } from "./action";
export { action };

export default function Login() {
  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 dark:text-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-20 w-auto"
          src="/logo-small.png"
          alt="Your Company"
        />
        <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight">
          Sign in to your Jordan's Teammate account
        </h2>
      </div>
      <a href="/" className="pt-2 block text-xs mx-auto text-center">
        Click here to go to the platform login
      </a>
      <div className="mt-7 sm:mx-auto sm:w-full sm:max-w-[480px] px-4">
        <Panel>
          <Outlet />
        </Panel>
      </div>
    </div>
  );
}
